var map = {
	"./audio-track-icon.svg": "./src/assets/icons/audio-track-icon.svg",
	"./badge.svg": "./src/assets/icons/badge.svg",
	"./banner-home-focus-icon.svg": "./src/assets/icons/banner-home-focus-icon.svg",
	"./banner-home-icon.svg": "./src/assets/icons/banner-home-icon.svg",
	"./banner-logo-icon.svg": "./src/assets/icons/banner-logo-icon.svg",
	"./banner-movies-focus-icon.svg": "./src/assets/icons/banner-movies-focus-icon.svg",
	"./banner-movies-icon.svg": "./src/assets/icons/banner-movies-icon.svg",
	"./banner-my-library-focus-icon.svg": "./src/assets/icons/banner-my-library-focus-icon.svg",
	"./banner-my-library-icon.svg": "./src/assets/icons/banner-my-library-icon.svg",
	"./banner-next-icon.svg": "./src/assets/icons/banner-next-icon.svg",
	"./banner-search-focus-icon.svg": "./src/assets/icons/banner-search-focus-icon.svg",
	"./banner-search-icon.svg": "./src/assets/icons/banner-search-icon.svg",
	"./banner-setting-focus-icon.svg": "./src/assets/icons/banner-setting-focus-icon.svg",
	"./banner-setting-icon.svg": "./src/assets/icons/banner-setting-icon.svg",
	"./banner-shows-focus-icon.svg": "./src/assets/icons/banner-shows-focus-icon.svg",
	"./banner-shows-icon.svg": "./src/assets/icons/banner-shows-icon.svg",
	"./banner-sports-focus-icon.svg": "./src/assets/icons/banner-sports-focus-icon.svg",
	"./banner-sports-icon.svg": "./src/assets/icons/banner-sports-icon.svg",
	"./card-subscirbe-icon.svg": "./src/assets/icons/card-subscirbe-icon.svg",
	"./check-icon.svg": "./src/assets/icons/check-icon.svg",
	"./chevron-right-icon.svg": "./src/assets/icons/chevron-right-icon.svg",
	"./empty-data-icon.svg": "./src/assets/icons/empty-data-icon.svg",
	"./empty-season.svg": "./src/assets/icons/empty-season.svg",
	"./fallback-logo.svg": "./src/assets/icons/fallback-logo.svg",
	"./homeSkeletonLogo.svg": "./src/assets/icons/homeSkeletonLogo.svg",
	"./keyboard-delete-icon.svg": "./src/assets/icons/keyboard-delete-icon.svg",
	"./keyboard-space-icon.svg": "./src/assets/icons/keyboard-space-icon.svg",
	"./minus-icon.svg": "./src/assets/icons/minus-icon.svg",
	"./more-info.svg": "./src/assets/icons/more-info.svg",
	"./offline-icon.svg": "./src/assets/icons/offline-icon.svg",
	"./pause-icon.svg": "./src/assets/icons/pause-icon.svg",
	"./play-black-icon.svg": "./src/assets/icons/play-black-icon.svg",
	"./play-icon.svg": "./src/assets/icons/play-icon.svg",
	"./play-white-icon.svg": "./src/assets/icons/play-white-icon.svg",
	"./plus-icon.svg": "./src/assets/icons/plus-icon.svg",
	"./qr-loading.svg": "./src/assets/icons/qr-loading.svg",
	"./qr-refresh.svg": "./src/assets/icons/qr-refresh.svg",
	"./qr-scanned.svg": "./src/assets/icons/qr-scanned.svg",
	"./quality-icon.svg": "./src/assets/icons/quality-icon.svg",
	"./scroll-indicator.svg": "./src/assets/icons/scroll-indicator.svg",
	"./setting-advance-mode-icon.svg": "./src/assets/icons/setting-advance-mode-icon.svg",
	"./setting-audio-icon.svg": "./src/assets/icons/setting-audio-icon.svg",
	"./setting-feedback-icon.svg": "./src/assets/icons/setting-feedback-icon.svg",
	"./setting-lang-icon.svg": "./src/assets/icons/setting-lang-icon.svg",
	"./setting-lang-selected-focus-icon.svg": "./src/assets/icons/setting-lang-selected-focus-icon.svg",
	"./setting-lang-selected-icon.svg": "./src/assets/icons/setting-lang-selected-icon.svg",
	"./setting-lang-unselect-focus-icon.svg": "./src/assets/icons/setting-lang-unselect-focus-icon.svg",
	"./setting-login-icon.svg": "./src/assets/icons/setting-login-icon.svg",
	"./setting-logout-icon.svg": "./src/assets/icons/setting-logout-icon.svg",
	"./setting-privacy-icon.svg": "./src/assets/icons/setting-privacy-icon.svg",
	"./setting-subscription-focused-icon.svg": "./src/assets/icons/setting-subscription-focused-icon.svg",
	"./setting-subscription-icon.svg": "./src/assets/icons/setting-subscription-icon.svg",
	"./setting-support-icon.svg": "./src/assets/icons/setting-support-icon.svg",
	"./setting-terms-icon.svg": "./src/assets/icons/setting-terms-icon.svg",
	"./settings-profile-icon.svg": "./src/assets/icons/settings-profile-icon.svg",
	"./show-episodes.svg": "./src/assets/icons/show-episodes.svg",
	"./shows-related.svg": "./src/assets/icons/shows-related.svg",
	"./shows-trailers.svg": "./src/assets/icons/shows-trailers.svg",
	"./subscirbe-infoList-analytical.svg": "./src/assets/icons/subscirbe-infoList-analytical.svg",
	"./subscirbe-infoList-football.svg": "./src/assets/icons/subscirbe-infoList-football.svg",
	"./subscribe-infoList-exclusive.svg": "./src/assets/icons/subscribe-infoList-exclusive.svg",
	"./subscribe-infoList-live.svg": "./src/assets/icons/subscribe-infoList-live.svg",
	"./subscribe-infoList-quality.svg": "./src/assets/icons/subscribe-infoList-quality.svg",
	"./subscribe-infoList-radio.svg": "./src/assets/icons/subscribe-infoList-radio.svg",
	"./subscribe_device_limit.svg": "./src/assets/icons/subscribe_device_limit.svg",
	"./video-loading-icon.svg": "./src/assets/icons/video-loading-icon.svg",
	"./videoPlayComplet.svg": "./src/assets/icons/videoPlayComplet.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync \\.svg$";